import { render, staticRenderFns } from "./icon-arrow-secondary.vue?vue&type=template&id=7718433f&scoped=true"
import script from "./icon-arrow-secondary.vue?vue&type=script&lang=js"
export * from "./icon-arrow-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7718433f",
  null
  
)

export default component.exports